// extracted by mini-css-extract-plugin
export default {"noticeContainer":"notice_noticeContainer__iZOk5","svg":"notice_svg__IzHv1","notice":"notice_notice__2+yNL","btn":"notice_btn__ehvBa"};